import React from "react";
import StaffAndRole from "component/StaffAndRoles/index";

export const StaffAndRolePage = () => {
  return (
    <>
      <StaffAndRole />
    </>
  );
};
